import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';

@Component({
  selector: 'app-receipt-list-item',
  templateUrl: './receipt-list-item.component.html',
})
export class ReceiptListItemComponent extends ExcTranslation {
  @ViewChild('VCThreePointMenue', {read: ElementRef}) VCThreePointMenue!: ElementRef;

  @Input()
  receipt: any;
  @Input()
  config = {
    singleSelect: false,
    actions: true,
    click: function() {} as any,
    dbclick: function() {} as any,
    action: [] as any[]
  };
  @Input()
  containerClass ? = 'list-row list-row-1-auto';

  constructor(
    public excRest: ExcRestService,
    public enumSvc: EnumerationService,
    public appSrv: ApplicationService
  ) {
    super();
  }

  doAction(action: any): void {
    this.receipt.expandThreePointMenue = false;
    if (action.action) {
      action.action();
    }
  }

  resetMenue(event: any): void {
    if (this.receipt.expandThreePointMenue) {
      this.receipt.expandThreePointMenue = this.receipt.expandThreePointMenue;
    }
  }
}
